const config = {};
export default config;



// WEBPACK FOOTER //
// ./config/base.js